import * as React from 'react';
import { useL2DTheme } from '@europrocurement/flexy-components/hooks';
import { FlexyButton } from '../FlexyButton/FlexyButton';

export type ContinueButtonProps = {
    libelle?: string;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    disabled?: boolean;
};

export const ContinueButton: React.FunctionComponent<ContinueButtonProps> = function (props) {
    const { onClick = () => {}, libelle = 'Continuer', disabled = false } = props;

    const { palette } = useL2DTheme();

    return (
        <FlexyButton
            data-testid="test-id-continueButton"
            label={libelle}
            size="large"
            variant="contained"
            color={palette.primary}
            disabled={disabled}
            onClick={onClick}
            sx={{
                width: '100%',
                marginTop: '30px',
                padding: '16px 24px 16px 24px',
                fontSize: '1rem',
                lineHeight: '1.5',
            }}
        />
    );
};
